import React, { createContext, useEffect, useContext, useState } from "react";
import axiosInstance from "../Config/axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";

export const ParentContext = createContext();


export const useParent = () => useContext(ParentContext);


export const ParentProvider = ({ children, user }) => {
  const [parentProfile, setParentProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const time_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const fetchLSParentDetails = async () => {
    const token = localStorage.getItem("accessToken");
    
    try {
      const response = await axiosInstance.get("/customer/parent-user-info/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data) {
        localStorage.removeItem("user");
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }

    } catch (err) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: err.response?.data?.detail || "Failed to fetch parent details.",
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });
      console.log(err.response?.data?.detail || "Failed to fetch parent details.");
      setParentProfile(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchCurrentParent = async () => {
    const token = localStorage.getItem("accessToken");

    if (!token || !user?.id) {
      setParentProfile(null);
      navigate("/login");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.get("/customer/parent-account/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data && typeof response.data === "object") {
        setParentProfile(response.data);
      } else {
        setParentProfile(null);
        navigate("/login");
      }
    } catch (err) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: err.response?.data?.detail || "Failed to fetch parent",
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });
      setParentProfile(null);
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const addParent = async (newData) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/customer/parent-account/", newData);
      setParentProfile(response.data);

      Swal.fire({
        icon: "success",
        title: "Account Created",
        text: "Parent account created successfully!",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: err.response?.data?.detail || "Failed to create account.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const updateParentProfile = async (updatedData) => {
    const token = localStorage.getItem("accessToken");

    if (!token || !user?.id) {
      Swal.fire({
        icon: "warning",
        title: "Unauthorized",
        text: "You must be logged in to update the profile.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      navigate("/login")
      return { success: false };
    }

    try {
      setLoading(true);
      const response = await axiosInstance.patch("/customer/parent-account/", updatedData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": updatedData instanceof FormData ? "multipart/form-data" : "application/json",
        },
      });

      setParentProfile(response.data);

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Profile updated successfully.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data?.detail || "Failed to update profile.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const changePasswordParentProfile = async (data) => {
    const token = localStorage.getItem("accessToken");

    if (!token || !user?.id) {
      Swal.fire({
        icon: "warning",
        title: "Unauthorized",
        text: "You must be logged in to update the profile.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      navigate("/login")
      return { success: false };
    }

    try {
      setLoading(true);
      const response = await axiosInstance.patch("/customer/change-password/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

     

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: response.data?.message || "Profile updated successfully.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: true, data: response.data };
    } catch (err) {

      console.log(err)
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data?.non_field_errors.map((i)=> i) || "Failed to update password.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const forgotPassword = async (data) => {
    localStorage.clear();

    try {
      setLoading(true);

      const response = await axiosInstance.post(
        "/customer/forgot-password/send-otp/",
        data
      );

      Swal.fire({
        icon: "success",
        title: "OTP Sent",
        text: "A password reset OTP has been sent to your email.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: err.response?.data?.detail || "Failed to send OTP.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

const VerifyOTP = async (data) => {
  try {
    setLoading(true);
    

    const response = await axiosInstance.post(
      "/customer/forgot-password/verify-otp/",
      data
    );

    const message = response.data?.message || "OTP verified successfully.";
    const token = response.data?.token || null;
    if (token) {
      localStorage.setItem("resetToken", token);
    }

    Swal.fire({
      icon: "success",
      title: "OTP verified.",
      text: message,
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });

    return { success: true, data: response.data };
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: err.response?.data?.detail || "Failed to verify OTP.",
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });

    return { success: false };
  } finally {
    setLoading(false);
  }
};

const resetPassword = async (data) => {
  try {
    setLoading(true);
    const token = localStorage.getItem("resetToken");
    

    const response = await axiosInstance.post(
      "/customer/forgot-password/reset/",
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const message = response.data?.message || "Password reset successfully.";
    localStorage.removeItem("resetToken");
    localStorage.removeItem("resetEmail");


    Swal.fire({
      icon: "success",
      title: "Password Reset",
      text: message,
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });

    return { success: true, data: response.data };
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: err.response?.data?.detail || "Failed to reset password.",
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });

    return { success: false };
  } finally {
    setLoading(false);
  }
};
const resetPasswordExisting = async (data) => {
  try {
    
    const response = await axiosInstance.post("/customer/password-reset/verify/", data);

    const message = response.data?.message || "Password reset successfully.";
    
    
    Swal.fire({
      icon: "success",
      title: "Password Reset",
      text: message,
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
    });
    navigate("/login");

    return { success: true, data: response.data };
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: err.response?.data?.detail || "Failed to reset password.",
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });

    return { success: false };
  } finally {
    setLoading(false);
  }
};

const fetchParentPackages = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if(!accessToken){
      navigate('/login')
      return;
    }
    setLoading(true);

    try {
      const response = await axiosInstance.get(`/customer/my-packages/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: {  timezone: time_Zone, }
      });
      return response.data || [];
    } catch (err) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Failed",
      //   text: err.response?.data?.message || "Failed to fetch packages.",
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });
      console.log(err.response?.data?.message || "Failed to fetch packages.");
    } finally {
      setLoading(false);
    }
  };


  const fetchParentPaymentDetails = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if(!accessToken){
      navigate('/login')
      return;
    }
    setLoading(true);

    try {
      const response = await axiosInstance.get(`/customer/payment-history/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: {  timezone: time_Zone, }
      });
      return response.data?.sales || [];
    } catch (err) {
     
      // Swal.fire({
      //   icon: "error",
      //   title: "Failed",
      //   text: err.response?.data?.message || "Failed to fetch payment details.",
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });
      console.log(err.response?.data?.message || "Failed to fetch payment details.");
    } finally {
      setLoading(false);
    }
  };


  
 const cancelSubscription = async (data) => {
    const accessToken = localStorage.getItem("accessToken");
   if(!accessToken){
      navigate('/login')
      return;
    }
  try {
    setLoading(true);

    const response = await axiosInstance.post(
      "/payment/cancel-subscription/",
      data,{
        params: {  timezone: time_Zone, }
      }
    );

    Swal.fire({
      icon: "success",
      title: "Cancelled",
      text: "Your subscription has been canceled successfully.",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
    });

    return { success: true, data: response.data };

  } catch (err) {

    Swal.fire({
      icon: "error",
      title: "Cancellation Failed",
      text: err?.response?.data?.message || "Failed to cancel subscription.",
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });

    return { success: false };

  } finally {
    setLoading(false);
  }
};



  const fetchMySessions = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/customer/my-event-bookings/`);
      
      return response?.data;
    } catch (err) {
    //   Swal.fire({
    //   icon: "error",
    //   title: "Cancellation Failed",
    //   text: err?.response?.data?.message || "Failed to cancel subscription.",
    //   confirmButtonColor: "#f7931a",
    //     cancelButtonColor: "#1C1C1C",
    // });

    console.log(err?.response?.data?.message || "Failed to fetch sessions.");
    } finally {
      setLoading(false);
    }
  };


  const checkBookingCancelStatus = async (bookingId) => {

    try {
      const response = await axiosInstance.get(`/customer/bookings/${bookingId}/check-cancel/`);
      
      return response.data;
    } catch (err) {
      const errorDetail = err.response?.data?.detail || "Failed to check cancel status";
      console.log(errorDetail);
      return null;
    }
  };

// for cancel sessions 
const cancelBooking = async (bookingId, isLateCancel, cancellationFee) => {
  
 
  try {
    let body = null;

    
    if (isLateCancel) {
      const formData = new FormData();
      formData.append("confirm_cancellation_fee", true);
      body = formData;
    }

    const response = await axiosInstance.patch(
      `/customer/bookings/${bookingId}/cancel/`,
      body,
      {
        headers: {
          
          "Content-Type": "multipart/form-data",
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Booking Cancelled",
      text: response.data?.message || "Your session has been cancelled successfully.",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
    });

    return response.data;
  } catch (err) {
    const errorDetail = err.response?.data?.detail || "Failed to cancel the booking";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: errorDetail,
      confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
    });
    // console.log(errorDetail);
    return null;
  }
};




  // useEffect(() => {
  //   const token = localStorage.getItem("accessToken");
  //   if (user?.id && token) {
  //     fetchCurrentParent();
  //   } else {
  //     setParentProfile(null);
  //   }
  // }, [user?.id, location.pathname]);

  return (
    <ParentContext.Provider
      value={{
        parentProfile,
        loading,
        fetchLSParentDetails,
        fetchCurrentParent,
        updateParentProfile,
        forgotPassword,
        addParent,
        VerifyOTP,
        resetPassword,
        changePasswordParentProfile,
        fetchParentPackages,
        fetchParentPaymentDetails,
        cancelSubscription,
        fetchMySessions,
        checkBookingCancelStatus,
        cancelBooking,
        resetPasswordExisting
      }}
    >
      {loading && (
       <Loader/>
      )}
      {children}
    </ParentContext.Provider>
  );
};
